import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Nigerian NIN generator following Single Responsibility Principle
 */
export class NgGenerator extends BaseGenerator {
  generate() {
    // Generate first 10 digits
    const digits = this.randomDigits(10);
    
    // Calculate check digit
    const weights = [3, 7, 3, 7, 3, 7, 3, 7, 3, 7];
    let sum = 0;

    for (let i = 0; i < 10; i++) {
      sum += parseInt(digits[i]) * weights[i];
    }

    const checkDigit = sum % 10;
    return digits + checkDigit;
  }
}